import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import App from './App.tsx';
import './index.css';
import { debugEnv } from './utils/env';
import { queryClient } from './queryClient';
import { reloadOnceForStaleChunk, clearStaleChunkReloadFlag } from './utils/lazyWithRetry';
import { initSentry } from './utils/sentry';

// Error tracking — ต้องมาก่อน render เพื่อจับ error ตั้งแต่ mount แรก (no-op ถ้าไม่มี VITE_SENTRY_DSN)
initSentry();

// Debug environment variables in development
if (import.meta.env.DEV) {
  debugEnv();
}

// หลัง deploy frontend ชื่อ chunk เปลี่ยน → tab เก่า preload/import chunk เดิมไม่เจอ
// Vite ยิง event นี้แทน throw (เช่นตอน preload CSS/JS ของ route ถัดไป) → reload 1 ครั้งให้ได้ชุดใหม่
window.addEventListener('vite:preloadError', (event) => {
  if (reloadOnceForStaleChunk()) {
    event.preventDefault();
  }
});
// แอพโหลดสำเร็จแล้วสักพัก → ล้าง guard เพื่อให้ deploy รอบถัดไป trigger reload ได้อีก
window.setTimeout(clearStaleChunkReloadFlag, 15_000);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      {/* React Query Devtools - แสดงเฉพาะใน development mode */}
      {import.meta.env.DEV && (
        <ReactQueryDevtools 
          initialIsOpen={false}
          position="bottom"
        />
      )}
    </QueryClientProvider>
  </React.StrictMode>,
);